export default __webpack_public_path__ + "static/media/announcement-white.db0da906.svg";